import React, { useEffect } from "react";
import { Button } from "antd";
import { AndroidOutlined, AppleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchMobileAppDetails } from "../redux/Slices/onboardingSlice";
import Loader from "./Common/Loader";

const OnboardClientSuccess = () => {
  const dispatch = useDispatch();
  const { mobileAppDetails, loading, error } = useSelector(
    (state) => state.onboarding
  );

  useEffect(() => {
    dispatch(fetchMobileAppDetails());
  }, [dispatch]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="error-container">
        <p className="error-message">
          Failed to load app details. Please try again later.
        </p>
      </div>
    );
  }

  return (
    <div className="success-page">
      <div className="success-container">
        <h1 className="success-title">🎉 Onboarding Completed Successfully!</h1>
        <p className="success-message">
          Thank you for completing the onboarding process. You’re all set to get
          started!
        </p>
        <p className="success-submessage">
          Please click the links below to download the application:
        </p>
        <div className="download-buttons">
          <Button
            type="primary"
            icon={<AndroidOutlined />}
            size="large"
            className="download-button android"
            href={
              mobileAppDetails?.AndroidUrl || "https://play.google.com/store"
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            Download for Android
          </Button>
          <Button
            type="primary"
            icon={<AppleOutlined />}
            size="large"
            className="download-button ios"
            href={
              mobileAppDetails?.IOSUrl || "https://www.apple.com/app-store/"
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            Download for iOS
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnboardClientSuccess;
